/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import pinia from "../stores";
import router from "@/router";
import permissions from "@/plugins/permissions";
import noAutofill from "@/plugins/noAutofill";

// Types
import type { App } from "vue";

export function registerPlugins(app: App) {
  app.use(vuetify).use(pinia).use(router).use(permissions).use(noAutofill);
}
